import { createAction, props } from '@ngrx/store';
import { IStaticDataResponse } from '../models/static-data.model';

export const loadProductProviders = createAction('[StaticData] Load ProductProviders');

export const loadProductProvidersSuccess = createAction(
  '[StaticData] Load ProductProviders Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadProductProvidersFailure = createAction('[StaticData] Load ProductProviders Failure', props<{ error: any }>());
